import { produce } from "immer";
import Actions from "../actions";

const initialState = {
  userCards: [],
  paymentDetails: {},
  paymentDialog: false,
  validateCouponData: {},
  tax: {},
};

const payment = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_ALL_USER_CARDS: {
      draft.userCards = payload;
      break;
    }

    case Actions.GET_TAX_DETAILS: {
      draft.tax = payload;
      break;
    }
    case Actions.PAYMENT_INTENT_DATA: {
      draft.paymentDetails = payload;
      break;
    }

    case Actions.CLEAR_PAYMENT_INTENT_DATA: {
      draft.paymentDetails = {};
      draft.userCards = [];
      break;
    }
    case Actions.PAYMENT_SUCCESS: {
      draft.paymentDialog = true;
      break;
    }
    case Actions.PAYMENT_FAIL: {
      draft.paymentDialog = false;
      break;
    }

    case Actions.GET_VALIDATE_COUPON: {
      if (payload?.validateCouponData?.is_valid) {
        draft.validateCouponData = payload?.validateCouponData;
      }
      break;
    }

    case Actions.CLEAR_COUPON: {
      draft.validateCouponData = {};
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default payment;
